import { ROLES } from "../constants/roles";

// Shared by Login.js, SelectTenantPage.js, useTenantSwitcher.js, and
// CrossLoginBridge.js — previously each duplicated this same localStorage
// write block independently, drifting slightly (SelectTenantPage/switcher
// keyed on `data.roles`/`data.id` fields from select-tenant/switch-tenant
// responses, which use the same shape as signin's `roles`/`id`).
export function persistSessionTokens(data) {
  localStorage.setItem("token", data.token);
  if (data.refreshToken) localStorage.setItem("refreshToken", data.refreshToken);
  localStorage.setItem("urserMail", data.email);
  localStorage.setItem("userRole", data.roles);
  localStorage.setItem("userId", data.id);
  if (data.activeTenantId === null || data.activeTenantId === "") {
    localStorage.removeItem("currentTenantId");
  } else if (data.activeTenantId !== undefined) {
    localStorage.setItem("currentTenantId", String(data.activeTenantId));
  }
  localStorage.setItem("isSuperAdmin", data.isSuperAdmin ? "true" : "false");

  if (data.roles === ROLES.SUPER_ADMIN || data.roles === ROLES.ACCOUNT_MANAGER) {
    localStorage.setItem("admin_id", data.hubspot_user_id);
  }
}

// Super admins may hold an unscoped session with no tenant (backend signin issues activeTenantId null)
export function needsTenantSelection() {
  return !localStorage.getItem("currentTenantId") && localStorage.getItem("isSuperAdmin") !== "true";
}

const FILTER_STATE_KEYS = ["filterPayload", "sortDB", "walkingListFilters", "sortWalking"];

const GHOST_SESSION_KEYS = [
  "ghostMode", "admin_id", "userId", "username", "firstname", "lastname", "hubspot_user_id", "userListLastUpdated",
];

export function clearGhostSession() {
  GHOST_SESSION_KEYS.forEach((key) => localStorage.removeItem(key));
}

export function clearFilterState() {
  FILTER_STATE_KEYS.forEach((key) => localStorage.removeItem(key));
}
